export const errorMessages = {
  //Impersonation
  IMPERSONATION_FAILURE: 'impersonate user',

  //Users
  GET_USERS_FAILURE: 'fetch users list',

  //Paging Signal
  PAGING_SIGNAL_FAILURE: 'access the network',

  //Data Sources
  GET_DATA_SOURCES_FAILURE: 'get data sources',
  ADD_DATA_SOURCE_FAILURE: 'create  data source',
  COPY_DATA_SOURCE_FAILURE: 'copy data source',
  UPDATE_SOURCE_INFO_FAILURE: 'update data source',
  DELETE_SOURCE_FAILURE: 'delete data source',

  //Data Sets
  GET_DATA_SETS_FAILURE: 'get Nexsets',
  GET_DATA_SET_FAILURE: 'get Nexset',
  UPDATE_DATA_SET_INFO_FAILURE: 'update Nexset',
  UPDATE_DATA_SET_RECIPE_FAILURE: 'update Nexset',
  ADD_DATASET_FAILURE: 'create Nexset',

  //share unshare

  SHARE_DATASET_FAILURE: 'share Nexset',
  UNSHARE_DATASET_FAILURE: 'unshare Nexset',

  //Available Nexsets
  GET_AVAILABLE_DATASETS_FAILURE: 'get shared Nexsets',

  //Data Sets samples
  GET_DATA_SAMPLES_FAILURE: 'get samples',
  GET_TRANSFORMED_SAMPLES_FAILURE: 'get samples',

  //My data sinks
  GET_SINKS_FAILURE: 'get data destinations',
  ADD_SINK_FAILURE: 'create data destination',
  ADD_SUB_TO_SINK_FAILURE: 'link this Nexset to destination',
  UPDATE_SINK_INFO_FAILURE: 'update data destination',
  DELETE_SINK_FAILURE: 'delete data destination',

  //Data Maps
  SET_PROPERTY_KEY_DATA_MAPS: 'save a key without a unique name',
  REMOVE_PRIMARY_KEY_PROPERTY_KEY_DATA_MAPS: 'remove a primary key without replacing it',
  DELETE_DATA_MAP_KEY: 'delete a primary key',

  //Credentials
  GET_ALL_CREDENTIALS_FAILURE: 'get credentials',
  ADD_CREDENTIAL_FAILURE: 'add credential',
  PROBE_CREDENTIAL_FAILURE: 'verify credential',
  UPDATE_CREDENTIAL_FAILURE: 'update credential',
  DELETE_CREDENTIAL_FAILURE: 'delete credential',

  //notifications
  GET_ALL_NOTIFICATIONS_FAILURE: 'get all notifications',
  GET_UNREAD_NOTIFICATIONS_FAILURE: 'get unread notifications',
  UPDATE_NOTIFICATION_AS_READ_FAILURE: 'mark notification as read',
  UPDATE_ALL_NOTIFICATIONS_AS_READ_FAILURE: 'mark all notifications as read',

  //resource metrics
  GET_RESOURCE_METRICS_AGGREGATE_FAILURE: 'get metrics',
  GET_RESOURCE_METRICS_BY_DAYS_FAILURE: 'get daily metrics',

  //user metrics
  GET_USER_ACCOUNT_SUMMARY_FAILURE: 'get user account metrics',
  GET_USER_RESOURCE_METRICS_N_DAYS_FAILURE: 'get user account metrics',
  GET_USER_RESOURCE_METRICS_AGGREGATE_FAILURE: 'get user account metrics',
  //Probe actions
  PROBE_GET_TREE_FAILURE: 'get folder tree',

  //Transform actions

  GET_TRANSFORM_FEATURES_FAILURE: 'get transform features',
};
